<div class="page-content">
    <p-table #pTable [columns]="cols" [value]="unFrozenItems" [frozenValue]="frozenItems" [scrollable]="true"
        scrollHeight="flex" scrollDirection="both" [rowHover]="true" styleClass="p-datatable-gridlines p-datatable-sm"
        [resizableColumns]="true" columnResizeMode="expand">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th class="headerName" pFrozenColumn><p-header></p-header></th>
                <ng-container *ngFor="let col of columns">
                    <th class="headerName" pFrozenColumn [frozen]="col?.isFrozenColumn">
                        <p-header>{{ col.header }}</p-header>
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="frozenbody" let-orderData let-index="rowIndex">
            <tr class="frozen-section">
                <td class="headerName" pFrozenColumn [ngClass]="{'move-text-to-top': orderData.key === 'photo'}">
                    {{ orderData.headerName }}
                </td>
                <ng-container *ngFor="let value of orderData.values; let i = index">
                    <td class="temp-color" pFrozenColumn [frozen]="value?.isFrozenColumn"
                        *ngIf="orderData.key === 'photo'">
                        <cv-custom-p-table-comp-grid-cell-image [value]="value.value">
                        </cv-custom-p-table-comp-grid-cell-image>
                    </td>
                    <td class="public-records" pFrozenColumn [frozen]="value?.isFrozenColumn"
                        *ngIf="orderData.key === 'publicRecords'">
                        <cv-custom-p-table-comp-grid-cell-public-records [orderData]="orderData"
                            [frozenItems]="frozenItems" [unFrozenItems]="unFrozenItems" [columnKey]="value.columnKey">
                        </cv-custom-p-table-comp-grid-cell-public-records>
                    </td>
                    <td class="align-items-stretch" style="padding:0" pFrozenColumn [frozen]="value?.isFrozenColumn"
                        *ngIf="orderData.key === 'address'">
                        <cv-custom-p-table-comp-grid-cell [value]="value"></cv-custom-p-table-comp-grid-cell>
                    </td>
                </ng-container>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-orderData let-index="rowIndex">
            <tr [ngClass]="{'row-accessories': orderData.type === 'separator'}">
                <td [ngClass]="{'headerName': orderData.type !== 'separator'}" pFrozenColumn>
                    {{ orderData.headerName }}
                </td>
                <ng-container *ngFor="let value of orderData.values">
                    <td class="align-items-stretch" style="padding:0" pFrozenColumn [frozen]="value?.isFrozenColumn">
                        <cv-custom-p-table-comp-grid-cell [value]="value"
                            (updateScroll)="updateScroll()"></cv-custom-p-table-comp-grid-cell>
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
</div>